import {
  AngularComponentsModule,
  GoabButton,
  GoabCheckbox,
  GoabCheckboxOnChangeDetail,
  GoabDivider,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioGroupOnChangeDetail,
  GoabRadioItem,
  GoabText,
} from '@abgov/angular-components';
import {
  PreventFocusScrollDirective,
  RadioItemHtmlLabelDirective,
  SnackbarService,
} from '@ala/common-ui';
import { CommonModule, Location } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';
import { NotificationService } from '@libs/services/notification.service';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';
import { FacilityCapacityEntryStateService } from '../../../../services-v2/states/facility-capacity-entry.state.service';
import { FacilityEntryBedRowStateService } from '../../../../services-v2/states/facility-entry-bed-row.state.service';

@Component({
  selector: 'app-facility-beds-editor-action',
  imports: [
    CommonModule,
    AngularComponentsModule,
    ReactiveFormsModule,
    GoabCheckbox,
    GoabRadioGroup,
    GoabRadioItem,
    GoabText,
    GoabDivider,
    GoabFormItem,
    GoabButton,
    PreventFocusScrollDirective,
    RadioItemHtmlLabelDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './facility-beds-editor-action.html',
  styleUrl: './facility-beds-editor-action.scss',
})
export class FacilityBedsEditorAction {
  private readonly _facilityEntryStateService = inject(
    FacilityCapacityEntryStateService
  );
  private readonly _facilityEntryBedRowStateService = inject(
    FacilityEntryBedRowStateService
  );
  private readonly _capacityReportState = inject(
    CapacityReportListStateService
  );
  private readonly _notificationService = inject(NotificationService);
  private readonly _snackbarService = inject(SnackbarService);
  private readonly _location = inject(Location);

  facilitySmokingPolicy = this._facilityEntryStateService.facilitySmokingPolicy;
  selectedFacilityBeds = this._facilityEntryStateService.selectedFacilityBeds;
  isSaveLaterable = this._facilityEntryStateService.entryChanged;

  chkNoChangeInvisible =
    this._facilityEntryStateService.isFirstWeekReportInFacility;

  isSubmittable(): boolean {
    return (
      this._facilityEntryBedRowStateService.allValidEntry() &&
      this._facilityEntryStateService.facilitySmokingPolicy() !== null
    );
  }

  onSaveLater() {
    // Nothing to do since all values have been auto-saved already
    this._facilityEntryStateService.setDrawerOpenClose = false;
    this._location.back();
  }

  onNoChangesCheckboxChange($event: GoabCheckboxOnChangeDetail) {
    console.log($event);
    //this.userCheckedNoChanges.set(event.checked);
  }
  onSmokingPolicyChange($event: GoabRadioGroupOnChangeDetail) {
    if ($event && $event.value) {
      const newValue = $event.value === 'true';
      this._facilityEntryStateService.setFacilitySmokingPolicy = newValue;
      this._facilityEntryStateService.setEntryChanged = true;
    }
  }
  async onSubmit() {
    if (this.isSubmittable()) {
      this._notificationService.isProgressIndicator.set(true);
      this._notificationService.progressIndicatorMessage.set(
        'Submitting capacity report...'
      );
      await this._facilityEntryStateService
        .submitCapacityReport()
        .then(() => {
          this._capacityReportState.updateCapacityReportStatus(
            this._facilityEntryStateService.selectedReportId(),
            CapacityReportStatus.COMPLETED
          );
          this._notificationService.isProgressIndicator.set(false);
          setTimeout(() => {
            this._snackbarService.showSuccess(
              `${this._facilityEntryStateService.selectedFacilityName()} report has been successfully submitted, and your smoking policy confirmation has been recorded`
            );
          }, 100);
        })
        .catch((error) => {
          this._notificationService.isProgressIndicator.set(false);
          console.error('Error submitting capacity report:', error);
          setTimeout(() => {
            this._snackbarService.showError(
              `${this._facilityEntryStateService.selectedFacilityName()} report was not submitted: ${
                error || 'Unknown error'
              }`
            );
          }, 100);
        });
      this._facilityEntryStateService.setDrawerOpenClose = false;
      this._location.back();
      await this._capacityReportState.loadCapacityReports();
    }
  }

  get facilitySmokingPolicyYesLabel() {
    return '<strong>Yes</strong>, we have a documented smoking policy.';
  }

  get facilitySmokingPolicyNoLabel() {
    return "<strong>No</strong>, we don't have a smoking policy, but we are creating one.";
  }
}
